<template>
    <a-drawer title="服务机构" :visible="visible" :wrap-class-name="drawerWrapClassName" destroy-on-close
              :mask-closable="false" @close="onClose" width="65%">
        <div class="ant-drawer-main">
            <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
                <a-form-item label="机构名称" name="companyName">
                    <a-input v-model:value="searchForm.companyName" placeholder="请输入机构名称"/>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="onSearch">查询</a-button>
                    <a-button @click="onReset">重置</a-button>
                </a-form-item>
            </a-form>
            <a-table
                :columns="columns"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :pagination="pagination"
                :data-source="dataSource"
                :loading="loading"
                @change="onTableChange">
                <!-- <template #index="{index}">{{ index + 1 }}</template> -->
                <template #serviceType="{text}">
                    <a-tag><dict-render :dict-obj="dictObjs['servicetypefuwu']" :text="text"></dict-render></a-tag>
                </template>
                <template #action="{record}">
                    <div class="table-row-operations">
                        <a @click="onButt(record)">对接</a>
                    </div>
                </template>
            </a-table>
        </div>
    </a-drawer>
</template>
<script>
import { formMixin, dictMixin,tableListMixin} from "@/mixins";
import {demandApi, MechanismInfoApi} from "@/api/innovationService";
import DictRender from "@/components/other/DictRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "机构名称", dataIndex: "name", key: "name"},
    {title: "服务类型", dataIndex: "serviceType", key: "serviceType",slots: {customRender: "serviceType"}},
    {title: "联系人", dataIndex: "contacts", key: "contacts"},
    {title: "联系电话", dataIndex: "phone", key: "phone"},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];

export default {
    name: "CompanyDarawer",
    mixins: [formMixin, dictMixin,tableListMixin],
    components: {DictRender},
    props: {jointId: String},
    data() {
        return {
            dictNames:'servicetypefuwu',
            columns,
            queryParamFixed: {

            },
            listUrl: MechanismInfoApi.pageExamineList,
            listKeyField: "id",
            needId: ""
        }
    },
    watch: {
        jointId() {
           this.loadData(1)
        }
    },
    methods: {
        onButt(record){
            this.postAction({
                url:demandApi.drawNeed,
                params:{
                    abutmentId:record.id,
                    abutmentType:"2",
                    needId:this.jointId
                }
            }).then(res=>{
                console.log(res,'res')
                    this.$notification.success({
                                message: '对接成功',
                                style: {
                                    fontWeight: '600',
                                },
                            });
            })
        },
        onClose(){
            this.visible = false
            this.$emit("onCloseModel")
        }
    }
}
</script>
